import React from "react";
import FormFulfillment from "../components/Forms/FormFulfillment/FormFulfillment";

import greenCircle from "../assets/icons/commons/greenCircle.svg";
import disabledCircle from "../assets/icons/commons/source-state-disabled.svg";


const Fulfillment: React.FC = () => {
    return (
        <div className="p-3">
            <div className="mt-4 md:mt-0 p-6 w-full max-w-2xl bg-white">
                <div className="flex items-center mb-4">
                    <img src={disabledCircle} alt="success" />
                    <span className='ml-2'>
                        Подключить Почту России
                    </span>
                </div>
                <FormFulfillment/>
            </div>
        </div>
    )
}

export default Fulfillment;